import styled from "styled-components";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { SuperButton } from "@swiggy-private/dls-web-core/dist/components/SuperButton";
import { getCornerRadius } from "@swiggy-private/dls-web-common/dist/components/themes/CornerRadiusMapping/mapping";

export const Container = styled.div<{ isJioHotstarFlow?: boolean }>(({ theme, isJioHotstarFlow }) => ({
    display: "flex",
    flexDirection: "column",
    margin: `${theme.spacing.xLarge} ${theme.spacing.medium} ${theme.spacing.xxSmall}`,
    ...(isJioHotstarFlow && {
        marginTop: theme.spacing.medium,
    }),
}));

export const SubTitleText = styled(Text)`
    margin-top: 6px;
    overflow: hidden;
    padding-right: 28px;
`;

export const ActionsSection = styled.div<{ isJioHotstarFlow?: boolean }>(({ theme, isJioHotstarFlow }) => ({
    width: "100%",
    margin: `${theme.spacing.xLarge} ${theme.spacing.empty} ${theme.spacing.empty}`,
    display: "flex",
    gap: theme.spacing.small,
    "& > div": {
        flex: 1,
    },
    ...(isJioHotstarFlow && {
        marginTop: theme.spacing.small,
    }),
}));

export const ActionButton = styled(SuperButton)(({ theme }) => ({
    borderRadius: getCornerRadius(theme, "small"),
}));

export const ContainerMeta = styled.div({
    display: "flex",
});

export const MetaTextWrapper = styled.div(({ theme }) => ({
    paddingLeft: theme.spacing.xSmall,
}));

export const InfoContainer = styled.div(({ theme }) => ({
    display: "flex",
    gap: "2px",
    marginTop: theme.spacing.xSmall,
}));
